<template>
  <div class="container-fluid pt-0">
    <DeleteGroup
      v-if="deletegroup"
      :show="deletegroup"
      v-on:closeDeleteGroupModal="deletegroup = false"
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- <div class="row">
      <div class="col-md-5">
        <h4 class="p-b-20">{{ $t("settings") }}</h4>
      </div>
    </div> -->
    <div
      v-if="mssg"
      align="center"
      class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x my-3"
    >
      <p class="alert-close mb-0">
        {{ mssg }}
      </p>
    </div>
    <div
      v-else-if="Errormssg"
      align="center"
      class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x my-3"
    >
      <p class="alert-close mb-0">
        {{ Errormssg }}
      </p>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6 col-sm-6">
            <div class="form-group mb-2">
              <label>{{ $t("grp_name") }}</label>
              <input type="text" v-model="groupname" class="form-control" />
            </div>

            <!-- <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("min-temp") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="min_temp"
                      class="form-control"
                      v-model="mintemp"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">°C</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("max-temp") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="max_temp"
                      class="form-control"
                      v-model="maxtemp"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">°C</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p v-if="tempmssg" class="my-0 small text-error p-1">
              {{ tempmssg }}
            </p>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("min-humid") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="minHumi"
                      class="form-control"
                      v-model="minHumi"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("max-humid") }}</label>
                  <div class="input-group">
                    <input
                      type="number"
                      name="maxHumi"
                      class="form-control"
                      v-model="maxHumi"
                      required
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p v-if="humimssg" class="my-0 mb-2 small text-error p-1">
              {{ humimssg }}
            </p> -->
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{ $t("short-desc") }} </label>
              <textarea
                rows="4"
                style="resize: none"
                class="form-control"
                name="group_description"
                v-model="group_description"
                required
              ></textarea>
              <span class="text-muted">150 {{ $t("words") }}</span>
            </div>

            <div class="form-group" v-if="canPerformAction('groups', 'edit')">
              <button
                @click="updategroup"
                class="btn btn-primary ml-auto d-block"
              >
                {{ $t("save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card">
      <div class="card-body">
        <div
          class="row"
          style="display: flex; justify-content: space-between; align-items: center"
        >
          <div class="col-md-8">
            <h5>{{ $t("del_group") }}</h5>
            <p class="mb-0">
              {{ $t("del_perm") }}
            </p>
          </div>
          <div class="col-md-4 deleterecord">
            <button class="btn btn-danger" @click="deletegroup = true">
              {{ $t("del_group") }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vClickOutside from "v-click-outside";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "../../store/index";
import DeleteGroup from "../Modals/DeleteGroup";

export default {
  name: "GroupSettings",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      deletegroup: false,
      groupname: "",
      group_description: "",
      mintemp: "",
      maxtemp: "",
      minHumi: "",
      maxHumi: "",
      tempmssg: "",
      humimssg: "",
      mssg: "",
      Errormssg: "",
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Loading,
    DeleteGroup,
  },
  computed: {
    ...mapGetters(["singlegroup", "profile", "canPerformAction"]),
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  methods: {
    ...mapActions(["deleteGroup", "fetchSingleGroup", "updateGroup"]),
    closeModal() {
      this.isOpen = false;
      this.onCancel();
    },
    openModal() {
      this.isOpen = true;
    },
    onCancel() {
      this.isLoading = false;
      this.confirmationModal = false;
      this.deleteErrormssg = "";
      this.deletemssg = "";
    },
    assignusers() {
      console.log("Users assigned");
    },

    updategroup() {
      this.tempmssg = "";
      this.humimssg = "";
      if (Number(this.mintemp) > Number(this.maxtemp)) {
        this.tempmssg = this.$t("min_temp_err");
      } else if (Number(this.minHumi) > Number(this.maxHumi)) {
        this.humimssg = this.$t("min_humid_err");
      } else {
        this.isLoading = true;
        const updatedgroup = {
          name: this.groupname,
          description: this.group_description,
          // minTemp: Number(this.mintemp),
          // maxTemp: Number(this.maxtemp),
          // minHumidity: Number(this.minHumi),
          // maxHumidity: Number(this.maxHumi),
          // company: this.profile.company._id || this.profile.company.id,
        };
        this.updateGroup({ id: this.$route.params.id, updatedgroup })
          .then((res) => {
            this.isLoading = false;
            this.mssg = res.data.payload.message;
            setTimeout(() => {
              this.mssg = "";
            }, 4000);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg = error.response.data.payload.message;
            // error.response can be null
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
  watch: {
    showModal(val) {
      if (val === this.$route.name) {
        this.deletegroup = true;
      }
      this.$emit("close_modal");
    },
    singlegroup: {
      handler: function () {
        this.groupname = this.singlegroup.group.name;
        this.group_description = this.singlegroup.group.description;
        // this.mintemp = this.singlegroup.group.minTemp;
        // this.maxtemp = this.singlegroup.group.maxTemp;
        // this.minHumi = this.singlegroup.group.minHumidity;
        // this.maxHumi = this.singlegroup.group.maxHumidity;
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    showModal: String,
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .deleterecord {
    display: flex;
    margin-top: 3px;
    justify-content: flex-start !important;
  }
}
.deleterecord {
  display: flex;
  justify-content: flex-end;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<i18n>
{
	"en": {
		"del_group": "Delete Group",
		"del_perm": "Delete this group permanently? This action is not reversible",
		"grp_name": "Group Name",
		"min_humid_err": "Minimum humidity cannot be greater than maximum humidity",
		"min_temp_err": "Minimum temperature cannot be greater than maximum temperature",
		"settings": "Settings",
		"words": "words"
	},
	"es": {
		"del_group": "Eliminar grupo",
		"del_perm": "¿Eliminar este grupo de forma permanente? Esta acción no es reversible",
		"grp_name": "Nombre del grupo",
		"min_humid_err": "La humedad mínima no puede ser mayor que la humedad máxima",
		"min_temp_err": "La temperatura mínima no puede ser mayor que la temperatura máxima",
		"settings": "Ajustes",
		"words": "palabras"
	},
	"fr": {
		"del_group": "Supprimer le groupe",
		"del_perm": "Supprimer définitivement ce groupe ? Cette action n'est pas réversible",
		"grp_name": "Nom de groupe",
		"min_humid_err": "L'humidité minimale ne peut pas être supérieure à l'humidité maximale",
		"min_temp_err": "La température minimale ne peut pas être supérieure à la température maximale",
		"settings": "Paramètres",
		"words": "mots"
	},
	"sw": {
		"del_group": "Futa Kikundi",
		"del_perm": "Ungependa kufuta kikundi hiki kabisa? Kitendo hiki hakiwezi kutenduliwa",
		"grp_name": "Jina la kikundi",
		"min_humid_err": "Unyevu wa chini hauwezi kuwa mkubwa kuliko unyevu wa juu zaidi",
		"min_temp_err": "Kiwango cha chini cha halijoto hakiwezi kuwa kikubwa kuliko kiwango cha juu cha halijoto",
		"settings": "Mipangilio",
		"words": "Maneno"
	}
}
</i18n>
